function escapeCsv(value: unknown): string {
  if (value == null) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export interface CsvColumn<T extends Record<string, unknown> = Record<string, unknown>> {
  key: string;
  label: string;
  getValue?: (row: T) => unknown;
}

export function rowsToCsv<T extends Record<string, unknown>>(
  rows: T[],
  columns: CsvColumn<T>[],
  includeSerial = true,
  serialOffset = 0,
): string {
  const headerCols = includeSerial
    ? [{ key: '__sno', label: 'S.No' }, ...columns]
    : columns;
  const header = headerCols.map((c) => escapeCsv(c.label)).join(',');
  const body = rows.map((row, index) =>
    headerCols.map((col) => {
      if (col.key === '__sno') return String(serialOffset + index + 1);
      const custom = 'getValue' in col && col.getValue ? col.getValue(row) : row[col.key];
      return escapeCsv(custom);
    }).join(','),
  );
  return [header, ...body].join('\n');
}

export function downloadListCsv(csv: string, fileName: string) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
